import {FormRowKey} from "../../../../types/form-field.types";

export const advertisementInitialStatisticsRowKeys: Array<FormRowKey> = [
  {
    key: 'fileAndPrice',
    className: 'initial-advertisement-statistics-double'
  },
  {
    key: 'fraction',
    className: 'initial-advertisement-statistics-fields'
  },
  {
    key: 'bloggerBelief'
  },
  {
    key: 'audience',
    className: 'initial-advertisement-statistics-fields'
  },
  {
    key: 'viewsBoostingAndRoscom',
    className: 'initial-advertisement-statistics-double'
  },
  {
    key: 'region',
    className: 'initial-advertisement-statistics-double'
  },
  {
    key: 'engagementRate'
  },
  {
    key: 'coverage',
    className: 'initial-advertisement-statistics-double'
  },
  {
    key: 'kasAndKyr',
    className: 'initial-advertisement-statistics-double',
    isHidden: true
  },
  {
    key: 'link'
  }
]
